import React, { useContext, useEffect } from 'react';

import AccordionContext from './Context';
import * as S from './styles';
import { IAccordionItemProps } from './types';

export const AccordionItem: React.FC<IAccordionItemProps> = ({
  title,
  uniqueKey,
  children,
}) => {
  const { expanded, disabled, handleToggle, keys, setKeys } =
    useContext(AccordionContext);

  useEffect(() => {
    setKeys([...keys, uniqueKey]);
  }, []);

  const state = {
    expanded: expanded.includes(uniqueKey),
    disabled: disabled.includes(uniqueKey),
  };

  const cssStyle = [];
  cssStyle.push(state.expanded ? 'expanded' : 'collapsed');
  cssStyle.push(state.disabled ? 'disabled' : '');

  return (
    <S.AccordionItem className={cssStyle.join(' ')}>
      <S.Header
        type="button"
        onClick={() => handleToggle(uniqueKey)}
        className={cssStyle.join(' ')}
      >
        {title}
      </S.Header>
      <S.Body className={state.expanded ? 'expanded' : 'collapsed'}>
        <div className="item-body">{children}</div>
      </S.Body>
    </S.AccordionItem>
  );
};
